import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canWrite } from '../utils/roles';
import api from '../services/api';
import ChecklistPage from './ChecklistPage';
import './EventEquipmentPage.css';

export default function EventEquipmentPage() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const canEdit = canWrite(user, 'agenda.equipos.evento');
  const [checklistId, setChecklistId] = useState(null);
  const [eventName, setEventName] = useState('Equipos del evento');
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    api.get(`/checklists/event/${eventId}`)
      .then(({ data }) => {
        if (!active) return;
        const checklists = Array.isArray(data) ? data : [];
        const carga = checklists.find(item => item.type === 'CARGA') || checklists[0];
        setChecklistId(carga?.id || null);
        setEventName(carga?.event_name || 'Equipos del evento');
      })
      .catch(err => {
        if (active) setError(err.response?.data?.error || 'No se pudieron cargar los equipos del evento.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [eventId]);

  async function createChecklist() {
    if (!canEdit || creating) return;
    setCreating(true);
    setError('');
    try {
      const { data } = await api.post('/checklists', { event_id: Number(eventId), type: 'CARGA' });
      setChecklistId(data.id);
      setEventName(data.event_name || eventName);
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo crear la lista de equipos.');
    } finally {
      setCreating(false);
    }
  }

  return (
    <div className="event-equipment-page">
      <header className="event-equipment-header">
        <button className="btn btn-ghost" type="button" onClick={() => navigate(-1)}>← Volver</button>
        <h1>Equipos del evento</h1>
      </header>

      {loading && <div className="event-equipment-state"><div className="spinner" /> Cargando equipos...</div>}
      {error && <div className="alert alert-error">{error}</div>}
      {!loading && !error && !checklistId && (
        <div className="event-equipment-empty">
          <h2>Este evento todavía no tiene una lista de equipos</h2>
          <p>{canEdit ? 'Podés crearla y comenzar a cargar equipos.' : 'Necesitás permiso de escritura para crearla.'}</p>
          {canEdit && <button className="btn btn-primary" type="button" disabled={creating} onClick={createChecklist}>{creating ? 'Creando...' : 'Crear lista de equipos'}</button>}
        </div>
      )}
      {checklistId && (
        <ChecklistPage
          checklistId={checklistId}
          panelMode
          onTabSwitch={setChecklistId}
        />
      )}
    </div>
  );
}
